<template>
    <div class="ah-panel outsourcing-bank-list-edit">
        <div class="panel-header small gray">
            <div class="panel-title">收款帳戶</div>
        </div>
        <div class="panel-body">
            <el-card v-for="(vendorBank, i) in value" :key="i" class="card">
                <div slot="header" class="clearfix">
                    <span>帳戶 {{ i + 1 }}</span>
                    <el-button v-if="value.length > 1" style="float: right; padding: 3px 0" type="text" @click.prevent="onDelete(i)">刪除</el-button>
                </div>
                <el-form-item prop="vendorBank.accountType" label="帳戶類型">
                    <el-radio-group v-model="vendorBank.accountType">
                        <el-radio :label="1">本國帳戶</el-radio>
                        <el-radio :label="2">外國帳戶</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item prop="vendorBank.bnK_TPC" label="戶名">
                    <el-input v-model="vendorBank.bnK_TPC" style="max-width: 550px" :maxlength="200" :show-word-limit="true"></el-input>
                </el-form-item>
                <el-form-item v-if="vendorBank.accountType === 1" prop="vendorBank.bnK_code" label="銀行">
                    <ah-el-select-bank v-model="vendorBank.bnK_BOO" :branch="vendorBank.bnK_DOO" @branchInput="vendorBank.bnK_DOO = $event" style="max-width: 550px"></ah-el-select-bank>
                </el-form-item>
                <el-form-item v-if="vendorBank.accountType === 2" prop="vendorBank.abroadBankName" label="銀行名稱（英文）">
                    <el-input v-model="vendorBank.abroadBankName" :maxlength="200" :show-word-limit="true"></el-input>
                </el-form-item>
                <el-form-item v-if="vendorBank.accountType === 2" prop="vendorBank.swiftCode" label="SWIFT Code">
                    <el-input v-model="vendorBank.swiftCode" style="max-width: 500px" :maxlength="40" :show-word-limit="true"></el-input>
                </el-form-item>
                <el-form-item prop="vendorBank.bnK_ACC" label="收款帳號">
                    <div style="max-width: 600px">
                        <ah-el-input-bank-acc v-model="vendorBank.bnK_ACC" :bankBoo="vendorBank.bnK_BOO" :maxlength="50"></ah-el-input-bank-acc>
                    </div>
                </el-form-item>
                <el-form-item prop="vendorBank.note">
                    <template slot="label">備註、其他資訊<ah-tip>收款人有多個帳號時，在申請請款中選用收款帳號的備註。</ah-tip></template>
                    <el-input v-model="vendorBank.note" style="max-width: 350px" :maxlength="50" :show-word-limit="true"></el-input>
                </el-form-item>
                <el-form-item prop="passbookDoc" label="存摺封面">
                    <div class="document-section">
                        <div>
                            <div v-if="vendorBank.passbookDoc" class="document-block">
                                <el-image :src="vendorBank.passbookDoc" :previewSrcList="[vendorBank.passbookDoc]" style="width: 100%; height: 100%" fit="contain"></el-image>
                            </div>
                            <ahUploader
                                :value="vendorBank.passbookDoc"
                                ref="ahUploader"
                                head-shot
                                accept="image/png, image/jpeg"
                                :watermark="`僅供 ${companyName} 請款使用`"
                                @change="($event) => onChangeAttachment($event, vendorBank, 'passbookDoc')"
                            />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item v-if="!noAgreeNeeded && vendorBank.bnK_TPC != '' && vendorBank.bnK_TPC != form.fnam" label="匯款同意書">
                    <div>
                        <el-alert type="warning" style="display: inline-block; width: auto; padding: 0 10px" :closable="false"
                            >收款戶名與廠商名稱不符，請付上匯款同意書與指定收款人帳戶存摺照片</el-alert
                        >
                    </div>
                    <el-upload
                        class="ah-img-upload-rect"
                        action="https://api.sokuji.tw/api/v1/Tool/UploadImg"
                        :data="{ uploadType: 1 }"
                        :headers="headers"
                        :show-file-list="false"
                        :on-success="
                            (res) => {
                                vendorBank.filE_AGREE = res.imgUrl;
                            }
                        "
                        :before-upload="beforeAvatarUpload"
                    >
                        <div v-if="vendorBank.filE_AGREE" class="upload-display change">
                            <img :src="vendorBank.filE_AGREE" alt="" class="uploaded-img" />
                            <div class="hint">更換檔案</div>
                        </div>
                        <div v-else class="upload-display">
                            <div class="text">上傳檔案</div>
                        </div>
                    </el-upload>
                </el-form-item>
            </el-card>
            <div style="text-align: right">
                <el-button @click="onAdd" type="primary" size="small" plain> 新增收款帳戶 </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import ahElSelectBank from '@/components/ui/ahElSelectBank.vue';
import ahElInputBankAcc from '@/components/ui/ahElInputBankAcc.vue';
import { checkFileSize, checkFilePictureType } from '@/utils/fileValidator';
import ahUploader from '@/components/ui/Uploader/ahUploader.vue';
import { computed } from 'vue';

export default {
    props: {
        form: {
            type: Object,
            default: () => {},
        },
        value: {
            type: Array,
            default: () => [],
        },
        noAgreeNeeded: {
            type: Boolean,
            default: false,
        },
    },
    components: { ahElSelectBank, ahElInputBankAcc, ahUploader },
    data() {
        return {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        };
    },
    computed: {
        companyName() {
            return this.$store.getters['menu/companyInfo'].cH_CMP;
        },
    },
    methods: {
        onAdd() {
            this.$emit('add');
        },
        onDelete(index) {
            this.$emit('delete', index);
        },
        beforeAvatarUpload(file) {
            const fileSizeErrMsg = checkFileSize(file.size);
            if (fileSizeErrMsg) {
                this.$message({
                    showClose: true,
                    message: fileSizeErrMsg,
                    type: 'error',
                });
                return false;
            }

            const fileTypeErrMsg = checkFilePictureType(file.type);
            if (fileTypeErrMsg) {
                this.$message({
                    showClose: true,
                    message: fileTypeErrMsg,
                    type: 'error',
                });
                return false;
            }
            return true;
        },
        onChangeAttachment(val, vendorBank, fieldName) {
            console.log('val', val);
            console.log('vendorBank', vendorBank);
            console.log('fieldName', fieldName);
            vendorBank[fieldName] = val.filE_ATT;
        },
    },
};
</script>

<style lang="scss" scoped>
.card {
    margin-bottom: 40px;
    border-radius: 15px;
    margin-bottom: 20px;
}
.outsourcing-bank-list-edit {
    .document-section {
        display: flex;
        > * {
            margin-right: 10px;
        }
    }
    .document-block {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 100px;
        border: 1px solid #aaa;
        cursor: pointer;
        .el-icon-plus {
            font-size: 30px;
            color: #aaa;
        }
    }
}
</style>
